import { render } from "./KullanicilarDetayView.vue?vue&type=template&id=08478dca&scoped=true"
import script from "./KullanicilarDetayView.vue?vue&type=script&lang=js"
export * from "./KullanicilarDetayView.vue?vue&type=script&lang=js"

import "./KullanicilarDetayView.vue?vue&type=style&index=0&id=08478dca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08478dca"]])

export default __exports__